// extracted by mini-css-extract-plugin
module.exports = {"container":"index-module--container--4a4RM","section":"index-module--section--INTdt"};